<template>
  <div>
    <b-col cols="12"
           md="12"
           lg="12">
      <b-row class="pt-2" align-h="end">
        <b-form-select v-model="inquiryPeriod"
                       size="sm"
                       style="width:18%;">
          <option value="inFiveYears">최근 5년간 추이</option>
          <option value="inThreeYears">최근 3년간 추이</option>
        </b-form-select>
      </b-row>
    </b-col>
    <apexchart ref="chart"
               v-if="data"
               type="line"
               :options="chartOptions"
               height="200"
               :series="series"/>
  </div>

</template>
<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: 'CT00040',
  props: ['data'],
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      inquiryPeriod: "inThreeYears",
      series: [],
      chartOptions: {
        chart: {

          height: 350,
          type: 'line',
          id: 'areachart-2',
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 5,
          curve: 'straight'
        },
        grid: {
          show: false,
          padding: {
            right: 30,
            left: 20
          }
        },
        yaxis: {
          show: false
        },
        legend: {
          show: true,
          position: 'bottom',
        }
      },
    }
  },
  created() {
    this.setLabels();
    this.setSeries();
  },
  watch: {
    data: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // this.setSeries();
          // this.setLabels();
        }
      }
    },
    inquiryPeriod: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setLabels();
          this.setSeries();
          this.refreshChart();
        }
      }
    }
  },
  methods: {
    async setSeries() {
      // 시각화 데이터 추출
      this.series = [];
      const now = new Date();
      let thisYear = now.getFullYear();
      let targetYear = thisYear;
      if (this.inquiryPeriod === 'inFiveYears') {
        targetYear = thisYear - 5
      } else {
        targetYear = thisYear - 3
      }
      let inquiredData = this.data.filter((data) => {
            const year = parseInt(data.year);
            return year > targetYear;
          }
      )


      let types = Array.from(new Set(inquiredData.map(obj => obj.target)));
      types.forEach(type => {
        let targetData = []
        this.chartOptions.labels.forEach(year => {
          targetData.push(inquiredData.filter(obj => obj.year === year && obj.target === type).length);
        })
        // targetDataArr[type]=targetData;
        this.series.push(
            {
              name: type,
              data: targetData
            }
        )
      })

    },
    async setLabels() {
      // 시각화 레이블 추출
      const now = new Date();
      let thisYear = now.getFullYear();
      let targetYear = thisYear;
      if (this.inquiryPeriod === 'inFiveYears') {
        targetYear = thisYear - 5
      } else {
        targetYear = thisYear - 3
      }
      let inquiredData = this.data.filter((data) => {
            const year = parseInt(data.year);
            return year > targetYear;
          }
      )
      this.chartOptions.labels = Array.from(new Set(inquiredData.map(obj => obj.year))).sort();
    },
  }
}
</script>
